// Mirrors SongUnknownSerializer.validate_spotify_link (api/serializers.py) -
// keep both in sync if this ever changes.
const SPOTIFY_ID_PATTERN = /track[:/]([\w-]*)/;
const MIN_SPOTIFY_ID_LENGTH = 8;

export const extractSpotifyId = (link) => {
  const match = SPOTIFY_ID_PATTERN.exec(link || "");
  if (!match) return null;
  return match[1].length >= MIN_SPOTIFY_ID_LENGTH ? match[1] : null;
};

// Spotify's own track name frequently carries noise a YouTube video
// title doesn't - remaster/year annotations, live-recording markers,
// featured-artist credits (already covered separately by the artist
// field SpotifyTrack returns - see api/views.py), edit/version labels.
// Left in, this reliably produces wrong or missing lyrics (confirmed:
// lrclib/Genius search on a "- Live" or "- Remastered 2011" suffixed
// title either 404s or matches an unrelated/junk result). Same
// conservative approach as cleanYoutubeTitle - only strips a
// recognized annotation, never attempts to split "Artist - Song".
const NOISE_KEYWORDS =
  "feat\\.?|featuring|with|remaster(?:ed)?(?:\\s*\\d{4})?|live|radio\\s+edit|single\\s+version|" +
  "album\\s+version|acoustic|extended|instrumental|mono|stereo|explicit|clean|bonus\\s+track";

export const cleanSpotifyTitle = (rawTitle) => {
  if (!rawTitle) return "";
  return rawTitle
    // Bracketed noise: "(feat. X)", "(Live)", "[Remastered 2011]", ...
    .replace(new RegExp(`[([][^)\\]]*\\b(${NOISE_KEYWORDS})\\b[^)\\]]*[)\\]]`, "gi"), "")
    // The same annotations as a trailing " - X" suffix instead, e.g.
    // "Bohemian Rhapsody - Remastered 2011" or "Song - Live".
    .replace(new RegExp(`\\s*[-–—]\\s*(\\d{4}\\s*)?(${NOISE_KEYWORDS})\\b.*$`, "i"), "")
    .replace(/\s{2,}/g, " ")
    .trim();
};
